<template>
  <div>
    <div class="line-three">
      <div class="flex three-class">
        <div class="icon-circle flex-x-y-center">
          <div class="iconfont icon-zhanghu icons"></div>
        </div>
        <div>
          <div class="my-pro">我的账户</div>
          <div class="id">
            账户名：{{ $parent.userInfo.username }}
            <!-- <span class="alter" @click="amends">修改账户名</span> -->
          </div>
        </div>
        <div class="flex-1">
          <div class="flex-end change-password" @click="changePasswords">
            修改密码
          </div>
        </div>
      </div>
    </div>
    <div class="line"></div>
    <el-dialog title="修改密码" :visible.sync="show_account" width="30%">
      <el-input
        v-model="passwordModel.oldpassword"
        placeholder="请输入原密码"
      ></el-input>
      <el-input
        v-model="passwordModel.newpassword"
        placeholder="请设置密码"
        style="margin-top: 15px"
      ></el-input>
      <el-input
        v-model="passwordModel.renewpassword"
        style="margin-top: 15px"
        placeholder="请确认密码"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show_account = false">取 消</el-button>
        <el-button type="primary" @click="saveNewPassword">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { changePassword } from "@/api";
import { mapActions } from "pinia";
import { useMainStore } from "@/store/piniaStore";
export default {
  data() {
    return {
      show_account: false,
      passwordModel: {
        newpassword: "",
        oldpassword: "",
        renewpassword: "",
      },
    };
  },
  methods: {
    ...mapActions(useMainStore, {
      token: "updateToken",
      changeProject: "updateProjectDetail",
      changUser: "updateUserInfo",
      changUserCert: "updateUserCertInfo",
    }),
    loginOut() {
      let that = this;
      that.token("");
      that.changUser({});
      that.changUserCert({});
      that.changeProject([]);
      that.$router.push("/login");
    },
    changePasswords() {
      this.show_account = true;
    },
    saveNewPassword() {
      changePassword(this.passwordModel).then((res) => {
        this.resData = res.data.data;
        if (res.data.code === 1) {
          console.log(res.data.data.msg);
          //修改完密码，退出账号
          this.loginOut();
        }
      });
    },
  },
  props: {
    // 流程
  },
};
</script>

<style scoped></style>
